<template>
  <div class="favorites-page">
    <template v-show="!pageLoading">
      <div class="recommendations-sections" v-show="showRecommendedBrandsSection">
        <div class="left-side">
          <h4 class="font-size-12">BULLETIN EDITS</h4>
          <h1>Our Picks for You</h1>
          <div class="buttons-row flex align-center justify-between">
            <bulletin-button class="see-all-btn" :to="'/favorites/recommended-brands'">See All</bulletin-button>
            <favorite-carousel-control
              :carousel-ref="$refs.recommendationsCarouselRef"
              :number-of-items="recommendedBrands.length"
            />
          </div>
        </div>

        <div class="right-side">
          <favorite-brands-carousel
            ref="recommendationsCarouselRef"
            :brands="recommendedBrands"
            :slides-per-view="3"
            :max-items="maxItemsOfRecommendedBrands"
            :see-all-link-to="'recommended-brands'"
            bordered-tiles
          />
        </div>
      </div>

      <template>
        <div class="favorites-section" v-show="showFavoriteBrandsSection && !favoriteBrandsLoading">
          <h1>Brands You Follow</h1>

          <div class="buttons-row flex align-center justify-between">
            <bulletin-button class="see-all-btn" :to="'/favorites/favorite-brands'">See All</bulletin-button>
            <favorite-carousel-control
              :carousel-ref="$refs.favoriteBrandsCarouselRef"
              :number-of-items="favoriteBrands.length"
            />
          </div>

          <favorite-brands-carousel
            :brands="favoriteBrands"
            ref="favoriteBrandsCarouselRef"
            :max-items="maxItemsOfFavoriteBrands"
            :see-all-link-to="'favorite-brands'"
          />
        </div>
        <favorite-brands-empty-state v-if="!showFavoriteBrandsSection && !favoriteBrandsLoading" />
      </template>

      <template>
        <div class="favorites-section" v-show="showFavoriteProductsSection && !favoriteProductsLoading">
          <h1>Products You Saved</h1>

          <div class="buttons-row flex align-center justify-between">
            <bulletin-button class="see-all-btn" :to="'/favorites/favorite-products'">See All</bulletin-button>
            <favorite-carousel-control
              :carousel-ref="$refs.favoriteProductsCarouselRef"
              :number-of-items="favoriteProducts.length"
              :mobile-slides-per-view="2"
            />
          </div>

          <favorite-products-carousel
            :products="favoriteProducts"
            ref="favoriteProductsCarouselRef"
            :max-items="maxItemsOfFavoriteProducts"
            :see-all-link-to="'favorite-products'"
            :mobile-slides-per-view="2"
            is-product
          />
        </div>

        <favorite-products-empty-state
          v-if="!showFavoriteProductsSection && !favoriteProductsLoading"
          class="no-padding-bottom"
        />
      </template>
    </template>

    <div class="flex align-center justify-center padding-top-240" v-if="pageLoading">
      <loader-static />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

h1 {
  font-size: 48px;
  line-height: 64px;

  @include respond-to("medium") {
    font-size: 32px;
    line-height: 40px;
  }
}

h4 {
  margin-bottom: 8px;
}

.favorites-page {
  padding-bottom: 56px;
  min-height: 80vh;
}

.buttons-row {
  margin-bottom: 24px;
  margin-top: 16px;
  .see-all-btn {
    width: 128px;
    min-width: unset !important;
  }
}

.recommendations-sections,
.favorites-section {
  padding: 40px;

  @include respond-to("medium") {
    padding: 40px 16px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid black;
  }
}

.recommendations-sections {
  background: url("~@/assets/img/favorites_bg.png") no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;

  @include respond-to("medium") {
    flex-direction: column;
    align-items: unset;

    .left-side,
    .right-side {
      width: 100% !important;
      min-width: unset !important;
      margin: 0;
    }
  }

  .left-side {
    min-width: calc(25vw - 40px);
    width: calc(25vw - 40px);
    margin-right: 24px;
  }

  .right-side {
    min-width: calc(75vw - 88px);
    width: calc(75vw - 88px);
  }
}

.favorites-section {
  h1 {
    margin-top: 16px;
  }
}
</style>

<script>
import FavoriteProductsCarousel from "./favoriteProductsCarousel";
import FavoriteBrandsCarousel from "./favoriteBrandsCarousel";
import FavoriteCarouselControl from "./favoriteCarouselControl";
import FavoriteBrandsEmptyState from "./emptyStates/favoriteBrandsEmptyState.vue";
import FavoriteProductsEmptyState from "./emptyStates/favoriteProductsEmptyState.vue";
import { favoritesPageHelper } from "./favoritesPageHelper";

export default {
  mixins: [favoritesPageHelper],
  components: {
    FavoriteCarouselControl,
    FavoriteBrandsCarousel,
    FavoriteProductsCarousel,
    FavoriteBrandsEmptyState,
    FavoriteProductsEmptyState,
  },
  data() {
    return {
      loaded: false,
      brands: [],
      favoriteProductObjects: [],
    };
  },
  async mounted() {
    this.fetchBrandObjects();
    this.getFavoriteProducts();
  },
  computed: {
    showRecommendedBrandsSection() {
      return this.recommendedBrands?.length;
    },
    showFavoriteProductsSection() {
      return this.favoriteProducts?.length;
    },
    showFavoriteBrandsSection() {
      return this.favoriteBrands?.length;
    },
    pageLoading() {
      return this.recommendedBrandsLoading && this.favoriteProductsLoading && this.favoriteBrandsLoading;
    },
    maxItemsOfRecommendedBrands() {
      return this.underBreakpoint("md") ? 4 : 8;
    },
    maxItemsOfFavoriteBrands() {
      return this.underBreakpoint("md") ? 4 : 11;
    },
    maxItemsOfFavoriteProducts() {
      return this.underBreakpoint("md") ? 8 : 11;
    },
  },
  watch: {},
};
</script>
